import { createFileRoute } from '@tanstack/react-router';
import { activeConfig } from '@/config';
import AuthVerifyPage from '@/components/pages/auth/verify';

export const Route = createFileRoute('/auth/verify')({
  head: () => ({
    meta: [{ title: `Verify Email | ${activeConfig.branding.appName}` }],
  }),
  component: AuthVerifyPage,
});
